import { render, staticRenderFns } from "./ItemPerfect.vue?vue&type=template&id=969d141c&scoped=true"
import script from "./ItemPerfect.vue?vue&type=script&lang=ts"
export * from "./ItemPerfect.vue?vue&type=script&lang=ts"
import style0 from "./ItemPerfect.vue?vue&type=style&index=0&id=969d141c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969d141c",
  null
  
)

export default component.exports